import { useEffect, useRef, type ReactNode } from 'react';
import { X } from 'lucide-react';

export function Modal({ title, children, onClose, error, className = '' }: { title: string; children: ReactNode; onClose: () => void; error?: string; className?: string }) {
  const element = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    element.current?.showModal();
    return () => previous?.focus();
  }, []);
  return <dialog ref={element} className={`modal-panel ${className}`} aria-label={title} onCancel={event => { event.preventDefault(); onClose(); }} onClick={event => {
    if (event.target !== element.current) return;
    const bounds = element.current.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) onClose();
  }}>
    <div className="panel-head"><h2>{title}</h2><button type="button" className="icon-button" onClick={onClose} title="Close"><X size={18} /></button></div>
    {error && <p className="error" role="alert">{error}</p>}
    {children}
  </dialog>;
}
